/* eslint-disable @typescript-eslint/no-unused-vars */
import { Action } from '@reduxjs/toolkit';
import { Epic, StateObservable, ofType } from 'redux-observable';
import { Observable, catchError, concatMap, from, map, of } from 'rxjs';

import { Dependencies } from '@configurations/dependencies/dependencies';
import { AnalystAssignment } from '@scenario/models/analyst-assignment.model';
import { RootState } from '@store/create-store';
import {
  retrieveAnalysts,
  retrieveAnalystsFailure,
  retrieveAnalystsSuccess,
} from '@store/scenario/analyst/analyst-slice';

export const retrieveAnalystsEpic: Epic<Action, Action, RootState, Dependencies> = (
  action$: Observable<Action>,
  _state$: StateObservable<RootState>,
  dependencies: Dependencies,
) => action$.pipe(
  ofType(retrieveAnalysts.type),
  concatMap(() => from(dependencies.analystGateway.retrieveAll()).pipe(
    map((analysts: AnalystAssignment[]) => retrieveAnalystsSuccess(analysts)),
    catchError(() => of(retrieveAnalystsFailure('Failed to retrieve analysts'))),
  )),
);
